<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>基础数据报表</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入场时间">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="datetimerange"
                    align="right"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['08:00:00', '07:59:59']">
                </el-date-picker>
            </el-form-item>
             <el-form-item label="">
                <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                <el-button plain @click="resetSelect()">重 置</el-button>
                <el-button plain type="success" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="table" :data="list" :max-height="tableMaxHeight" show-summary :summary-method="getSummaries">
            <el-table-column label="序号" width="50" type="index">

            </el-table-column>
            <el-table-column label="时间" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.date}}</span>
                </template>
            </el-table-column>
            <el-table-column label="磅单号" width="140" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.poundSn}}</span>
                </template>
            </el-table-column>
            <el-table-column label="收货单位" width="240" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="主车号" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.plateNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="挂车号" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.carriageNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="皮重(吨)" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.firstWeight==0?'0.00':parseNums(scope.row.firstWeight)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="毛重(吨)" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.secondWeight==0?'0.00':parseNums(scope.row.secondWeight)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="净重(吨)" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.netWeight==0?'0.00':parseNums(scope.row.netWeight)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="单价(元/吨)" width="100" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.realPrice==null?'0.00':scope.row.realPrice}}</span>
                </template>
            </el-table-column>
             <el-table-column label="销售金额(元)" width="130px" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.realAmount==null?'0.00':parseFloat(scope.row.realAmount).toFixed(2)}}</span>
                </template>
            </el-table-column>
             <!-- <el-table-column label="预收账款(元)" width="130px" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.advances==null?'0.00':parseFloat(scope.row.advances).toFixed(2)}}</span>
                </template>
            </el-table-column> -->
             <el-table-column label="开票情况" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text" v-if="scope.row.billed==0">未开票</span>
                    <span class="primary_text" v-else-if="scope.row.billed==1">已开票</span>
                    <span class="primary_text" v-else></span>
                </template>
            </el-table-column>
        </el-table>
        <!-- <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="total, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer> -->
    </el-card>
</template>
<script>
import request from '@/utils/request'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'

export default {
    name:'summary_table',
    data(){
        return{
            is_ok:false,
            componys:[],
            selectForm:{
                comId:"",
                timeRange:[],
                // pageNum:1,
                // pageSize:15
            },
            tableMaxHeight:0,
            total:0,
            list:[],
            baseUrl:'',
            listData:{}
        }
    },
    methods:{
        resetSelect(){
            this.selectForm = {
                comId:"",
                timeRange:[],
                // pageNum:1,
                // pageSize:15
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
                this.componys.push( {id:"",name:"全部"})
            }).catch(err=>{
            });
        },
        getData(){
            if (this.selectForm.timeRange == null || this.selectForm.timeRange == '') {
                this.selectForm.timeRange = [];
            }
            request.post("report/basics",this.selectForm).then(res=>{
                console.log(res.data.pageInfo.list)
                this.list = res.data.pageInfo.list;
                this.listData=res.data;
                // this.total = res.data.total;
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            });
        },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        //保存到excel文件中
        async exportExcel(){
            try{
                let res = await fetch(this.baseUrl+"/report/basics_excel",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectForm)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "基础数据报表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                 if (index === 8) {
                    sums[index] = this.listData.totalNetWeight;
                    return;
                }
                 if (index === 10) {
                    sums[index] = parseFloat(this.listData.totalRealAmount).toFixed(2);
                    return;
                }
                //  if (index === 11) {
                //     sums[index] = parseFloat(this.listData.totalAdvances).toFixed(2);
                //     return;
                // }
            });

            return sums;
      },
      getNextDate(date,day){
        let dd=new Date(date);
        dd.setDate(dd.getDate()+day);
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        return y+'-'+m+'-'+d;
      },
      parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
    },
    created(){
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
    },
    mounted(){
        let dd=new Date();
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 08:00:00`
        let endTime=`${this.getNextDate(y+'-'+m+'-'+d,-0)} 7:59:59`
        this.selectForm.timeRange.push(startTime,endTime)
        this.getData();
        this.getCompany();
    }
}
</script>
<style scoped lang="scss">

</style>
